import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { LogoNames } from 'src/app/shared/enums/logoNames.enum';
import { LayoutService } from '../../../../RefModules/_metronic/core/services/layout.service';
import { User } from 'src/app/Modules/management/models/organization/user.model';

@Component({
    selector: 'app-settings-header',
    templateUrl: './settings-header.component.html',
    styleUrls: ['./settings-header.component.scss'],
})
export class SettingsHeaderComponent implements OnInit {
    IA = LogoNames.IA;
    ulCSSClasses: string;
    rootArrowEnabled: boolean;
    location: Location;
    headerMenuDesktopToggle: string;
    isGeneralSettingsEnabled: boolean = true;
    isInformateSettingsEnabled: boolean = true;
    isIdmsSettingsEnabled: boolean = true;
    isProfileSettingsEnabled: boolean = false;
    userDetails: User;
    curInstanceId: string;
    index: number = 0;

    constructor(
        private layout: LayoutService,
        private user_utility: UserUtilityService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    async ngOnInit(): Promise<void> {
        this.ulCSSClasses = this.layout.getStringCSSClasses('header_menu_nav');
        this.curInstanceId = localStorage.getItem('currentInstanceId');
        this.rootArrowEnabled = this.layout.getProp('header.menu.self.rootArrow');
        this.headerMenuDesktopToggle = this.layout.getProp('header.menu.desktop.toggle');
        //this.getUser();
        //checking routes and chage logo accourdingly
        if (this.router.url === '/settings/informate') {
            this.IA = LogoNames.JA;
        } else if (this.router.url === '/settings/idms') {
            this.IA = LogoNames.PA;
        } else {
            this.IA = LogoNames.IA;
        }

        //check for menus permission
        let instanceType = JSON.parse(localStorage.getItem('selectedInstanceDetails'));

        this.isGeneralSettingsEnabled = await this.user_utility.checkUserPermissionDataAndRoute('general', userActions.View);
        this.isInformateSettingsEnabled = await this.user_utility.checkUserPermissionDataAndRoute('view-informate-settings', userActions.View);
        let index = instanceType?.instanceType?.index ? instanceType.instanceType.index : instanceType[0]?.instanceType?.index;
        this.isIdmsSettingsEnabled = (await this.user_utility.checkUserPermissionDataAndRoute('view-idms-settings', userActions.View)) && index != 1;
        this.isProfileSettingsEnabled = await this.user_utility.checkUserPermissionDataAndRoute('profile', userActions.View);

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            if (event.url === '/settings/idms') {
                this.IA = LogoNames.PA;
            } else if (event.url === '/settings/informate') {
                this.IA = LogoNames.JA;
            } else {
                this.IA = LogoNames.IA;
            }
        });

        this.activatedRoute.queryParams.subscribe((params) => {
            this.index = +params['index'] || 0;
        });
    }
}
